import { useCallback } from 'react'
import { isChunkLoadError } from '../../lib/lazyWithRetry'
import styles from './styles.module.css'

type Props = {
  error: unknown
}

export function ErrorFallback({ error }: Props) {
  const chunkError = isChunkLoadError(error)

  const handleReload = useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <div className={styles.container}>
      {chunkError ? (
        <>
          <h1>アプリが更新されました</h1>
          <p>新しいバージョンが公開されています。ページをリロードしてください。</p>
        </>
      ) : (
        <>
          <h1>エラーが発生しました</h1>
          <p>予期しないエラーが発生しました。ページをリロードしてください。</p>
        </>
      )}
      <button className={styles.reloadButton} onClick={handleReload}>
        リロード
      </button>
    </div>
  )
}
